import { render, staticRenderFns } from "./AttractionsList.vue?vue&type=template&id=489c4d05"
import script from "./AttractionsList.vue?vue&type=script&lang=js"
export * from "./AttractionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports